<template>

  <form
    v-if="!isFormValid"
    v-on:submit.prevent="resetPassword">

    <div
      :class="{'is-error': userFormErrors.username}"
      class="form-control">
      <label
        for="username"
        class="form-label">{{ $t('views.forgottenPassword.form.username') }}</label>
      <div class="form-wrapper">
        <input
          v-model="userForm.username"
          v-on:input="removeFormError('username')"
          type="text"
          name="username"
          id="username"
          class="form-field"/>
      </div>
      <p
        v-if="userFormErrors.username"
        class="form-label is-error is-right-aligned">{{ $t('views.forgottenPassword.form.required') }}</p>
    </div>

    <div class="form-control is-right-aligned">
      <router-link :to="{name: 'login', params: { locale: $i18n.locale }}">{{ $t('views.forgottenPassword.form.back') }}</router-link>
    </div>

    <div class="form-control">
      <button
        :class="{'is-loading': isFormLoading}"
        class="button is-beta is-full">{{ $t('views.forgottenPassword.form.submit') }}</button>
    </div>

  </form>

  <div v-else>
      <p v-html="$t('views.forgottenPassword.success.content')"></p>
      <router-link
        :to="{name: 'login', params: { locale: $i18n.locale }}"
        tag="button"
        class="button is-gamma">
        {{ $t('views.forgottenPassword.success.cta') }}</router-link>
  </div>

</template>

<script>
import AUTH from '@/api/auth';

export default {
  name: 'login',
  components: {
  },
  data: () => ({
    userForm: {
      username: '',
    },
    userFormErrors: {},
    isFormValid: false,
    isFormLoading: false,
  }),
  computed: {

  },
  methods: {

    removeFormError(key) {
      this.isFormLoading = false;
      if (this.userFormErrors[key]) {
        delete this.userFormErrors[key];
      }
    },

    resetPassword() {
      this.isFormLoading = true;

      AUTH.passwordReset(this.userForm).then(
        (res) => {
          this.isFormLoading = false;
          this.isFormValid = true;
        }, (err) => {
          this.isFormLoading = false;
          this.userFormErrors = err;
        },
      );
    },

  },
};
</script>
